export default "__VITE_PUBLIC_ASSET__5dbe4ffb__"